var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "table", staticClass: "excel-table" }, [
    _c("table", [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th", [_vm._v("#")]),
            _vm._l(_vm.columns, function (col, index) {
              return _c("th", { key: index }, [
                _vm._v(" " + _vm._s(col.title) + " "),
                index !== 0
                  ? _c("div", { staticClass: "actions" }, [
                      _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSign(index)
                            },
                          },
                        },
                        [_vm._v("+/-")]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
          ],
          2
        ),
      ]),
      _c(
        "tbody",
        _vm._l(_vm.data, function (row, rowIndex) {
          return _c(
            "tr",
            {
              key: rowIndex,
              class: { highlight: _vm.activeRow === rowIndex },
              on: {
                keydown: function ($event) {
                  return _vm.handleKeydown($event, rowIndex)
                },
              },
            },
            [
              _c("td", { staticClass: "gray-background" }, [
                _vm._v(_vm._s(rowIndex)),
              ]),
              _vm._l(_vm.columns, function (col, colIndex) {
                return _c(
                  "td",
                  {
                    key: colIndex,
                    ref: function (el) {
                      if (el) {
                        _vm.cells[rowIndex][colIndex] = el
                      }
                    },
                    refInFor: true,
                    class: { "gray-background": colIndex === 0 },
                    attrs: { contenteditable: colIndex !== 0 },
                    on: {
                      click: function ($event) {
                        return _vm.focusCell(rowIndex, colIndex)
                      },
                      input: function ($event) {
                        return _vm.updateCellValue(
                          $event.target.innerText,
                          rowIndex,
                          colIndex
                        )
                      },
                      focus: _vm.startEditing,
                      blur: _vm.stopEditing,
                    },
                  },
                  [_vm._v(" " + _vm._s(row[col.key]) + " ")]
                )
              }),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }